import { apiFetch, apiJson } from './api';

export interface Highlight {
  id: string;
  userId: string;
  lawId?: string;
  articleId?: string;
  text: string;
  range?: string | null;
  note?: string | null;
  type?: 'highlight' | 'favorite';
  itemType?: 'article' | 'scjn_tesis' | 'scjn_sentencia' | 'dof_publication';
  articleNumber?: string;
  articleTitle?: string;
  articleContent?: string;
  scjnMetadata?: any;
  createdAt: string;
  updatedAt: string;
}

export interface CreateHighlightData {
  articleId?: string;
  lawId?: string;
  text: string;
  range?: string | null;
  note?: string | null;
  type?: 'highlight' | 'favorite';
  itemType?: 'article' | 'scjn_tesis' | 'scjn_sentencia' | 'dof_publication';
  articleNumber?: string;
  articleTitle?: string;
  articleContent?: string;
  scjnMetadata?: any;
}

export interface UpdateHighlightData {
  text?: string;
  note?: string | null;
  range?: string | null;
  type?: 'highlight' | 'favorite';
  itemType?: 'article' | 'scjn_tesis' | 'scjn_sentencia' | 'dof_publication';
  articleNumber?: string;
  articleTitle?: string;
  articleContent?: string;
  scjnMetadata?: any;
}

export async function getAllHighlights(options?: {
  type?: 'highlight' | 'favorite';
  itemType?: 'article' | 'scjn_tesis' | 'scjn_sentencia' | 'dof_publication';
  lawId?: string;
  articleId?: string;
}): Promise<Highlight[]> {
  const params = new URLSearchParams();
  if (options?.type) params.set('type', options.type);
  if (options?.itemType) params.set('itemType', options.itemType);
  if (options?.lawId) params.set('lawId', options.lawId);
  if (options?.articleId) params.set('articleId', options.articleId);
  const q = params.toString();
  const data = await apiJson<Highlight[]>(`/api/mobile/highlights${q ? `?${q}` : ''}`);
  return Array.isArray(data) ? data : [];
}

export async function createHighlight(data: CreateHighlightData): Promise<Highlight> {
  return apiJson<Highlight>('/api/mobile/highlights', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function updateHighlight(id: string, data: UpdateHighlightData): Promise<Highlight> {
  return apiJson<Highlight>(`/api/mobile/highlights/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}

export async function deleteHighlight(id: string): Promise<void> {
  const res = await apiFetch(`/api/mobile/highlights/${id}`, { method: 'DELETE' });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error((data as { error?: string })?.error || res.statusText || 'Error al eliminar');
  }
}

export function formatHighlightDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('es-MX', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
